export default "__VITE_ASSET__8qRLgDqW__"